import { ENVIRONMENT, ENVIRONMENTSEARCH, ENVIRONMENTECREPORT } from "./type";

const initialState = {environment: {}, environmentsearch: {}, environmentECReport: {}};

const environmentR = (state = initialState, action) =>{
    switch(action.type){
        case ENVIRONMENT:
            return {...state, environment: action.payload};
            
        case ENVIRONMENTSEARCH:
            return {...state, environmentsearch: action.payload};

        case ENVIRONMENTECREPORT:
            return {...state, environmentECReport: action.payload};

        default:
            return state;
    }
}

export default environmentR;